export class ImagingToolEvent {
  static DRAWING_TOOL_POINTER           = 'pointer';
  static DRAWING_TOOL_LINE              = 'line';
  static DRAWING_TOOL_RECTANGLE         = 'rectangle';
  static DRAWING_TOOL_CIRCLE            = 'circle';
  static DRAWING_TOOL_ARROW             = 'arrow';
  static DRAWING_TOOL_FILLED_RECTANGLE  = 'filled-rectangle';
  static DRAWING_TOOL_MULTI_POINT_LINE  = 'multi-point-line';
  static DRAWING_TOOL_SPRAY_CAN         = 'spray-can';
  static DRAWING_TOOL_PEN               = 'pen';
  static DRAWING_TOOL_FILL              = 'fill';

  static ORIENTATION_TOOL_FLIP_HORIZONTAL    = 'flip-horizontal';
  static ORIENTATION_TOOL_FLIP_VERTICAL      = 'flip-vertical';
  static ORIENTATION_TOOL_ROTATE_NINETY      = 'rotate-ninety';
  static ORIENTATION_TOOL_ROTATE_180         = 'rotate-180';
  static ORIENTATION_TOOL_ROTATE             = 'rotate';
  static ORIENTATION_TOOL_ROTATE_END         = 'rotateEnd';

  static CANVAS_TOOL_FILE_1           = 'file-1';
  static CANVAS_TOOL_FILE_2           = 'file-2';
  static CANVAS_TOOL_FILE_3           = 'file-3';
  static CANVAS_TOOL_INVERT_SELECTION = 'invert-selection';
  static CANVAS_TOOL_INVERT_COLOR     = 'invert-color';

  static ADJUSTMENT_TOOL_CROP       = 'crop';
  static ADJUSTMENT_TOOL_SUN        = 'sun';
  static ADJUSTMENT_TOOL_FLASHLIGHT = 'flashlight';
  static ADJUSTMENT_TOOL_TUNE       = 'tune';
  static ADJUSTMENT_TOOL_FILTRATION = 'filtration';
  static ADJUSTMENT_TOOL_AUTOMATIC_GEARBOX = 'automatic_gearbox';

  static TEXT_TOOL_TYPE     = 'type';
  static TEXT_TOOL_TEXT_BOX = 'text-box';
  static TEXT_TOOL_STAMP_1  = 'stamp-1';
  static TEXT_TOOL_STAMP_2  = 'stamp-2';

  static MAGNIFICATION_TOOL_RING_DETAILS  = 'ring-details';
  static MAGNIFICATION_TOOL_ZIPPER_SLIDER = 'zipper-slider';
  static MAGNIFICATION_TOOL_ANALYZE       = 'analyze';
  static MAGNIFICATION_TOOL_ZOOM_IN       = 'zoom-in';
  static MAGNIFICATION_TOOL_PREVIEW_PANE  = 'preview-pane';

  static FUNCTION_TOOL_RULER  = 'ruler';
  static FUNCTION_TOOL_LIPIDS = 'lipids';
  static FUNCTION_TOOL_UNDO = 'undo';
  static FUNCTION_TOOL_CLEAR = 'clear-annotations';
  static FUNCTION_TOOL_REVERT = 'revert-image';

  static BRIGHTNESS = 'brightness';
  static CONTRAST = 'contrast';
  static GAMMA = 'gamma';
  static USE_MOUSE = 'use-mouse';
  static LINE_SIZE = 'line-size';
  static COLOR      = 'color';
  static TEXT_COLOR      = 'text-color';
  static BEST_FIT   = 'best-fit';
  static SIZE       = 'size';

  type: string;
  value: any;
}
